<template>
  <v-layout class="">
    <!-- navigation drawer -->
    <v-navigation-drawer v-model="booleanValue" color="primary" dark app overflow
      :class="$vuetify.breakpoint.xsOnly ? 'bordered-drawer' : ''">
      <perfect-scrollbar :options="{ wheelSpeed: 0.5, wheelPropagation: true }" style="height: 100%; overflow: hidden">
        <v-list dense>
          <template v-if="datoLogin.id_colegio == 0">
            <div class="d-flex justify-center">
              <v-avatar width="150" height="auto" class="profile" tile>
                <img src="@/assets/inteligenio.png" />
              </v-avatar>
            </div>
          </template>

          <template v-else-if="datoLogin.logo_colegio == null">
            <v-avatar size="150" class="profile">
              <v-img src="@/assets/logo.png" />
            </v-avatar>
          </template>

          <template v-else>
            <div class="d-flex justify-center">
              <v-avatar width="120" height="auto" class="profile" tile>
                <img :src="`${rutaSpace}${datoLogin.logo_colegio}`" @error="setDefaultLogo" />
              </v-avatar>
            </div>
          </template>
          <v-list-item>
            <v-list-item-content>
              <span class="text-center text-h7 font-weight-bold" style="color:#fc0">
                {{ datoLogin.nombre_colegio }}
              </span>
            </v-list-item-content>
          </v-list-item>

          <v-list-group dense v-for="modulo in Datos" :key="modulo.id" color="yellow accent-4" class="custom-list-group"
            append-icon="mdi-chevron-down">

            <template v-slot:activator>
              <v-list-item-icon class="mr-2">
                <v-icon small>{{ modulo.icono_modulo }}</v-icon>
              </v-list-item-icon>
              <!-- <v-list-item-content class="font-weight-bold" style="font-size: 13px" >Módulo <br>{{modulo.nombre_modulo}}</v-list-item-content> -->
              <v-list-item-content class="subtitle-1 nav font-weight-bold">
                <p class="mb-0">
                  {{ $t(`modulos.${modulo.id}`).toUpperCase() }}
                </p>
              </v-list-item-content>
            </template>

            <!--  Ciclo for interno por Modulos  -->
            <div v-for="subModulo in modulo.subModulo" :key="subModulo.id">
              <v-list-item :to="subModulo.link_submodulo" @click="showDataSubmodulo(subModulo)">
                <!-- <v-list-item-icon>
                 
                </v-list-item-icon> -->

                <v-tooltip bottom open-delay="200">

                  <template v-slot:activator="{ on }">
                    <v-list-item-title v-on="on" class="ml-4" @click="
      tituloComp(
        $t(`modulos.${modulo.id}`),
        $t(`subModulos.${subModulo.id_submodulo}`)
      )
      ">
                      <v-icon small>mdi-chevron-right</v-icon>
                      {{
      $t(`subModulos.${subModulo.id_submodulo}`)
    }}
                    </v-list-item-title>

                  </template>
                  <span>
                    {{ $t(`subModulos.${subModulo.id_submodulo}`) }}
                  </span>
                </v-tooltip>

              </v-list-item>
            </div>
          </v-list-group>

          <!-- SUBMODULO OCULTO , SE VERÁ SOLO CUANDO ESTEMOS CORRIENDO EN DESARROLLO -->
          <v-list-group v-if="false" dense color="yellow accent-4" class="custom-list-group"
            append-icon="mdi-chevron-down">

            <template v-slot:activator>
              <v-list-item-icon class="mr-2">
                <v-icon small>mdi-xml</v-icon>
              </v-list-item-icon>
              <v-list-item-content class="subtitle-1 nav font-weight-bold">
                <p class="mb-0">Devs</p>
              </v-list-item-content>
            </template>
            <!--  Ciclo for interno por Modulos  -->
            <div>
              <v-list-item to="DevStyle">
                <!-- <v-list-item-icon>
                </v-list-item-icon> -->
                <v-list-item-title class="ml-4">
                  <v-icon small>mdi-chevron-right</v-icon>
                  Style
                </v-list-item-title>
              </v-list-item>
            </div>

          </v-list-group>

        </v-list>
      </perfect-scrollbar>
    </v-navigation-drawer>

    <Header :boolean-value="booleanValue" @toggle-value="toggleValue" />
    <v-main>

      <template v-if="containerComun">
        <div>
          <v-container>
            <div class="text-caption breadcrumb_style mb-4">
              {{ bread_crumb }}
            </div>
            <router-view :key="$route.query.id"></router-view>
            <!-- <slot /> -->
          </v-container>
        </div>
      </template>

      <template v-else>
        <div class="pa-3 fill-height">
          <!-- <slot /> -->
          <router-view></router-view>
        </div>
      </template>
    </v-main>
  </v-layout>
</template>

<script>
import Header from "@/layouts/header_administrativo";
// import MenuLateral from "@/layouts/menu_lateral";
import axios, { BUCKET_ORIGIN_SPACE, IS_DEV } from "../helpers/axios";
// import pathsEspeciales from "@/pathsEspeciales.js";

import { mapMutations } from "vuex";
export default {
  name: "LayoutAdministrativo",
  data: () => ({
    isDev: IS_DEV ? true : false, //VARIABLE QUE SERÁ TRUTY CUANDO ESTEMOS EN LOCAL
    containerComun: true,
    datoLogin: sessionStorage,
    rutaSpace: BUCKET_ORIGIN_SPACE,
    Datos: {},
    prueba: {},
    bread_crumb: "",
    iconbread: "",
    fab: false,
    booleanValue: true,
  }),
  components: {
    Header,
    // MenuLateral,
  },
  // mane: "MenuLateral",
  mounted() {
    this.loadMain();
    setTimeout(() => {
      this.set_breadcrumb();
    }, 1000);

    this.compararPath();
  },
  computed: {
  },
  methods: {
    ...mapMutations({
      setTituloMenu: "setTituloMenu",
      setSubmodulo: "login/setSubmodulo"
    }),
    // ...mapMutations('mensajeSis', ['setEnviarMens']),

    loadMain() {
      this.getMenuPerfil();
    },

    showDataSubmodulo(submodulo) {
      sessionStorage.setItem("id_modulo", submodulo.id_modulo);
      sessionStorage.setItem("id_submodulo", submodulo.id_submodulo);
      // this.setSubmodulo(submodulo)
    },

    toggleValue() {
      this.booleanValue = !this.booleanValue;
    },
    // Descripcion de titulos y Subtitulos en los Componetes del sistema
    tituloComp(modulo, submodulo) {
      let titulo = "Módulo " + `${modulo} / ${submodulo}`;
      // this.tituloPrincipalComponente = titulo;
      //`${modulo.nombre_modulo} / ${subModulo.nombre_submodulo}`
      setTimeout(this.setTituloMenu(titulo), 2000);

    },
    async set_breadcrumb() {
      const { path } = this.$route;
      await axios
        .get(`/sistema/main/breadcrumb/${path.substring(1, path.length)}`)
        .then((response) => {

          const { data: modules } = response;
          if (modules)
            this.tituloComp(
              modules.Module.nombre_modulo,
              modules.nombre_submodulo
            );
        });
    },
    //  ------- MOSTRAR TODOS LOS REGISTROS  --------
    async getMenuPerfil() {
      try {
        let parametros = {
          id_usuario: this.datoLogin.id,
          token: this.datoLogin.token_usuario,
        };
        let response = await axios.post("/sistema/main/menuPerfil", parametros);

        this.Datos = response.data.moduloSubModulo;

        console.warn('administrativo_academico.vue ::: MIS SUBMODULOS POR PERFIL', response.data);

      } catch (error) {
        //console.log(error);
      }
    },

    setDefaultLogo(event) {
      event.target.src = require('@/assets/inteligenio.png');
    },

    compararPath() {
      //Se constulta mediante el path si es necesita
      //un contendor común o uno especial
      const miPath = this.$route.path; //Mi path actual

      const contendedorEspecial = [
        "/programarReunion",
        "/homeManager",
        "/LibroTotal",
        "/DevStyle"
      ];

      this.containerComun =
        !contendedorEspecial.includes(miPath);
    },
  },
  watch: {
    $route(route) {
      // LOS BREADCRUMB SE DEFINIERON EN MAYUSCULA EN router.js
      // POR LO TANTO TEDRÉ QUE MODIFICARLO CON JS PARA DARLE EL FORMATO REQUERIDO

      let texto = route.meta.breadCrumb.toLowerCase()
      // texto=> "módulo inicio / buzón de mensajeria"
      try {
        // PARA PALABRAS QUE REQUIERAN MAYUSCULAS NECESARIAS COMO "Modulo de RRHH" debe ser necesario que lo corrijan en el router
        const cadenas = texto.split(" / ").map(txt => {
          return txt.charAt(0).toUpperCase() + txt.slice(1)
        }
        )
        this.bread_crumb = cadenas.join(" / ")

      } catch (error) {
        console.log(error);
        this.bread_crumb = texto

      }
      this.iconbread = this.Datos.icono_modulo;

      this.compararPath(route);
    },
  },
};
</script>

<style scoped>
.nav p:first-letter {
  text-transform: uppercase;
}

.custom-list-group .v-icon {
  font-size: 24px;
  /* Ajusta este valor al tamaño deseado */
}

.bordered-drawer {
  border-top-right-radius: 50px;
  border-bottom-right-radius: 50px;
  overflow: hidden;
}
</style>
